import { api } from './api';
export type UsagePeriod = 'month' | '7' | '30' | '90';
export interface UsageBucket {
  name: string;
  requests: number;
  costUsd: number;
}
export interface DailyUsage {
  date: string;
  requests: number;
  costUsd: number;
}
export interface CrmUsage {
  costUsd: number;
  entries: number;
  inputTokens: number;
  outputTokens: number;
  unknownRequests: number;
  legacyEntries: number;
  byModel: UsageBucket[];
  byWorkload: UsageBucket[];
  byDay: DailyUsage[];
}
export interface WhatsappUsage {
  source?: 'provider';
  costUpdatedAt?: string;
  stale?: boolean;
  unpricedDays?: string[];
  statsAvailable?: boolean;
  periodStart: string;
  periodEnd: string;
  trackingStartedAt: string | null;
  costUsd: number;
  uncertainReservedUsd: number | null;
  requests: number | null;
  inputTokens: number;
  outputTokens: number;
  cacheWriteTokens: number;
  cacheReadTokens: number;
  messages: number | null;
  activePhones: number | null;
  reviewCount: number | null;
  queueCount: number | null;
  deliveryStates: Record<string, number>;
  byDay: DailyUsage[];
  model: string;
  monthOpeningCostUsd: number | null;
  monthToDateCostUsd: number | null;
  applicationPeriodCapEnabled: boolean;
  circuitOpen: boolean;
  legacyCumulativeCostsIncluded: false;
}
export type UsageSource<T> =
  | { status: 'available'; data: T }
  | { status: 'unavailable'; reason: string };
export interface AiUsageOverview {
  period: UsagePeriod;
  periodStart: string;
  periodEnd: string;
  currency: string;
  costBasis: string;
  providerAccountMonthlyLimitUsd: number | null;
  crm: UsageSource<CrmUsage>;
  whatsapp: UsageSource<WhatsappUsage>;
}
export function fetchAiUsageOverview(
  period: UsagePeriod,
): Promise<AiUsageOverview> {
  return api.get<AiUsageOverview>(`/ai-usage/overview?period=${period}`);
}
